module.exports = __webpack_public_path__ + "static/img/pattern-img.375cf97c.png";